
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiResistor3Off as ObiResistor3OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-resistor-3-off.js';
 
 
 

 
 export const ObiResistor3Off = createComponent({
   react: React,
   tagName: 'obi-resistor-3-off',
   elementClass: ObiResistor3OffElement,
   events: {
     
   }
  });
 
 